<template>
  <v-form>
    <v-container v-if="GetBookingInfo() !== null && GetBookingInfo() !== undefined">
      <template v-for="(roomReserve, iroom) in GetBookingInfo()">
        <v-row no-gutters class="d-flex justify-space-between my-0 py-0" :key="iroom + 'add-guest'">
          <v-col cols="10">
            <span class="text-h6">{{ roomReserve.ratePlan.hotDealsType === 'PackageDeal'
              || roomReserve.ratePlan.hotDealsType === 'PayStayDeal' ? roomReserve.ratePlan.room.roomName :
              roomReserve.room.roomName }}</span>
            &nbsp;
            <span class="text-subtitle-2" style="color: #616161 !important;">{{ roomReserve.ratePlan.rateName }}
              <span v-if="roomReserve.ratePlan.isIncludeBreakfast">
              </br>
                <v-icon>mdi-silverware-fork-knife</v-icon>
                <span>
                  Breakfast Included
                </span>
              </span>
              <span v-if="roomReserve.ratePlan.isRefundable">
              </br>
                <v-icon>mdi-credit-card-refund</v-icon>
                <span>
                  Refundable
                </span>
              </span>
              <span v-if="!roomReserve.ratePlan.isRefundable">
              </br>
                <v-icon>mdi-cancel</v-icon>
                <span>
                  Non-Refundable
                </span>
              </span>
            </span> </v-col>
          <v-col cols="2" class="d-flex justify-end align-self-center">
            <v-btn icon color="red" @click="removeRoom(roomReserve)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row :key="'guest' + iroom">
          <v-col cols="6" lg="4" xl="4" md="4" sm="4" xs="6">
            <v-text-field v-model="roomReserve.firstName" label="First Name" dense solo></v-text-field>
          </v-col>
          <v-col cols="6" lg="4" xl="4" md="4" sm="4" xs="6">
            <v-text-field v-model="roomReserve.lastName" label="Last Name" dense solo></v-text-field>
          </v-col>
          <v-col cols="9" lg="4" xl="4" md="4" sm="4" xs="7">
            <v-text-field v-model="roomReserve.email" label="Email (Optional)" dense solo></v-text-field>
          </v-col>
        </v-row>
        <v-divider :key="'divi' + iroom"></v-divider>
      </template>
    </v-container>
    <!-- <v-btn depressed color="primary" class="ml-2" @click="onAddMoreRoom">
      ADD MORE ROOM
    </v-btn> -->
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  methods: {
    onAddMoreRoom: function () {
      this.$store.dispatch('setActiveScreen', 'room');
    },
    removeRoom: function (room) {
      this.$store.dispatch('removeRoom', room);
    }
  },
  computed: {
    ...mapGetters(["GetBookingInfo"]),
  },
};
</script>